import script from "./FooterComp.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterComp.vue?vue&type=script&setup=true&lang=js"

import "./FooterComp.vue?vue&type=style&index=0&id=0cac53a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cac53a2"]])

export default __exports__